const { useState, useEffect } = require("react");

const usePlatform = () => {
    const [platform, setPlatform] = useState("Unknown");

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            setPlatform("Android");
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            setPlatform("iOS");
        } else {
            setPlatform("Desktop");
        }
    }, []);
    return platform;
}

export { usePlatform }